export default {
  baseUrl: '//ldev.gunet.gr/nlg-api',
  baseUrlConfig: '//ldev.gunet.gr/nlg-api'
}



// WEBPACK FOOTER //
// ./src/config.js